module.exports = __webpack_public_path__ + "static/media/Vector6.ef15f884.svg";